module.exports = __webpack_public_path__ + "img/title02.f7b1b2a7.png";